import { atcb_action } from 'add-to-calendar-button';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Button } from '@soluto-private/mx-asurion-ui-react';

import { LoggerWarning } from '@service-initiation/shared-clients-logger';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  convertTime12to24,
  getFormattedDate,
} from '@service-initiation/shared-utils-date-time';

import { type AddToCalendarProps } from './types';

const CalendarButton = styled(Button)``;

type CalendarEventProps = {
  event: string;
};

type CalendarTypeProps = {
  eventLabel: string | undefined;
};

export const AddToCalendar = ({
  availability = 'busy',
  buttonText,
  clickAnalytics,
  currentStep,
  description = 'Device repair appointment with ubreakIfix by asurion',
  endTime,
  hideBackground = true,
  listStyle = 'dropdown',
  location,
  name,
  onClick,
  options = ['Apple', 'Google', 'Yahoo', 'Outlook.com'],
  startDate,
  startTime,
  timeZone = 'currentBrowser',
  trigger = 'click',
}: AddToCalendarProps) => {
  const [lastEvent, setLastEvent] = useState<CalendarTypeProps>({
    eventLabel: undefined,
  });

  const config = {
    availability,
    description,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    endTime: convertTime12to24(endTime!),
    hideBackground,
    listStyle,
    location,
    name,
    options,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    startDate: getFormattedDate(startDate!),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    startTime: convertTime12to24(startTime!),
    timeZone,
    trigger,
  };

  const handleClick = () => {
    try {
      atcb_action(config);
      onClick?.();
    } catch (error) {
      logger.warn(new LoggerWarning('Failed to add event to calendar', error));
    }
  };

  useEffect(() => {
    // eslint-disable-next-line
    const listener = (event: any) => {
      const calendarEvents = event.view.dataLayer.filter(
        (calendarEvent: CalendarEventProps) =>
          calendarEvent.event === 'openCalendarLink'
      );

      if (calendarEvents && calendarEvents.length > 0) {
        setLastEvent(calendarEvents[calendarEvents.length - 1]);
      }
    };

    document.addEventListener('click', listener);

    return () => {
      document.removeEventListener('click', listener);
    };
  }, [lastEvent]);

  useEffect(() => {
    clickAnalytics?.({ ActionId: lastEvent.eventLabel });
  }, [lastEvent, clickAnalytics]);

  return (
    <CalendarButton
      color="primary"
      data-analytics-action-id="AddToCalendar"
      data-analytics-cta="AddToCalendar"
      data-analytics-step-name={currentStep}
      data-testid="AddToCalendar"
      iconSide="left"
      iconSrc="calendar"
      onClick={handleClick}
      size="medium"
      variant="default"
    >
      {buttonText}
    </CalendarButton>
  );
};
